import { divideByFactorRate } from './prices'

export const percentageFormatter = (value: number): string => {
  return divideByFactorRate(value).toLocaleString(undefined, {
    style: 'percent',
    minimumFractionDigits: 2,
  })
}

export const isNumber = (value?: number | null): value is number => {
  return typeof value === 'number' && isFinite(value) && !isNaN(value)
}
